/*
 * サブシステム名：マスタ管理
 * 機能名：人員マスタ登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import { mapGetters } from 'vuex'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

import header from '@/ddv2.library/header'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdFileInput = () => import('@/components/DdFileInput')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdPasswordBox = () => import('@/components/DdPasswordBox')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')

const ERRORMESSAGEIMAGEPICKED = '画像ファイルを選択してください。'
const ERRORMESSAGEREQUIREPASSWORD = '入力してください。'
const ERRORMESSAGECHECKPASSWORD = '一致しません。'
var HYOJIORDERMSTMENKYOSHO = 1
var HYOJIORDERMSTKAZOKUJOHO = 1
var HYOJIORDERMSTJINJIHENKO = 1
var HYOJIORDERMSTRIREKIJOHO = 1
var HYOJIORDERMSTKEIREKIJOHO = 1
var HYOJIORDERMSTSHIKAKUJOHO = 1
var HYOJIORDERMSTSHOBATSUJOHO = 1
var HYOJIORDERMSTTEKISEISHINDAN = 1
var HYOJIORDERMSTJIKOREKI = 1
var HYOJIORDERMSTIHANREKI = 1
var HYOJIORDERMSTTOKUBETSUKYOIKU = 1
var HYOJIORDERMSTKENKOSHINDAN = 1

export default {
  name: 'MstJininEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdFileInput,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdPasswordBox,
    DdSubHeader,
    DdSectionTitle,
    DdSimpleTable,
    DdSwitch,
    DdTextArea,
    DdTextBox
  },
  data: () => ({
    id: 0,
    copyMode: false,
    rec: {
      // 入力項目動的DOM管理用（支給項目単価）
      shikyuKomokuTanka: {},
      // 入力項目動的DOM管理用（控除項目単価）
      koujoKomokuTanka: {},
      // 人員マスタ
      mstJinin: {},
      // 顔写真マスタ
      mstFaceImage: {},
      // 住居情報マスタ
      mstJukyoJoho: {},
      // 運転免許情報マスタ
      mstMenkyosho: [],
      mstMenkyoshoDel: [],
      // 運転免許情報マスタ 共通入力項目 外出し
      menkyoshoNo: '',
      menkyoShuruiKbn: '',
      menkyoJoken: '',
      shutokuYmdString: '',
      // 家族情報マスタ
      mstKazokuJoho: [],
      mstKazokuJohoDel: [],
      // 人事変更マスタ
      mstJinjiHenko: [],
      mstJinjiHenkoDel: [],
      // 履歴情報マスタ
      mstRirekiJoho: [],
      mstRirekiJohoDel: [],
      // 経歴情報マスタ
      mstKeirekiJoho: [],
      mstKeirekiJohoDel: [],
      // 資格情報マスタ
      mstShikakuJoho: [],
      mstShikakuJohoDel: [],
      // 賞罰情報マスタ
      mstShobatsuJoho: [],
      mstShobatsuJohoDel: [],
      // 適性診断マスタ
      mstTekiseiShindan: [],
      mstTekiseiShindanDel: [],
      // 事故歴マスタ
      mstJikoreki: [],
      mstJikorekiDel: [],
      // 違反歴マスタ
      mstIhanreki: [],
      mstIhanrekiDel: [],
      // 特別教育マスタ
      mstTokubetsuKyoiku: [],
      mstTokubetsuKyoikuDel: [],
      // 健康診断マスタ
      mstKenkoShindan: [],
      mstKenkoShindanDel: [],
      // パスワード更新フラグ
      passwordRegistFlg: false,
      // 顔写真削除フラグ
      photoDeleteFlg: false
    },
    invalidMessages: {},
    // 写真登録ポップアップ
    photo_regist: false,
    photo: {},
    photoClone: {},
    // パスワード変更ポップアップ
    password_regist: false,
    currentpassword: false,
    newpassword: false,
    againpassword: false,
    password: {},
    passwordClone: {},
    passwordCurrentDisp: false,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersKengenGroupList: header.mstKengenGroupHeaders,
    // 表示制御
    isAnkerLinkDisp: false,
    // 更新モード 0:新規、1:照会、2:更新
    modeOfEdit: 2,
    // 権限情報 0:読取、1:削除不可、2:フル
    modeKengen: 2,
    // 初期カラー
    chipColorTmp: ''
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      kengenGroupList: 'DDMasters/vwCMstKengenGroup01',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      msyssystemconfig: 'DDMasters/msysSystemConfig',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredKengenGroupList () {
      return this.kengenGroupList
    },
    filterRiyoKikan: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'riyo_kikan'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    isJomuin () {
      if (!this.rec.mstJinin.jomuFlg) {
        return false
      }
      return true
    },
    /* --------------------
      入力項目
    -------------------- */
    // 支給項目単価
    filteredShikyuKomokuTankaWk () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFFK01'
      }).map(function (elem) {
        elem.value = elem.code
        elem.text = elem.codeNm
        return elem
      }).sort((a, b) => {
        if (a.code < b.code) { return -1 }
        if (a.code > b.code) { return 1 }
        return 0
      })
    },
    // 支給項目単価（画面表示用に整形）
    filteredShikyuKomokuTanka () {
      var array = this.filteredShikyuKomokuTankaWk
      var result = []
      var list = {}
      for (var i = 0; i <= Math.floor((array.length - 1) / 2); i++) {
        list = {}
        list.lists = array.slice(i * 2, i * 2 + 2)
        result.push(list)
      }
      return result
    },
    // 控除項目単価
    filteredKoujoKomokuTankaWk () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFFK02'
      }).map(function (elem) {
        elem.value = elem.code
        elem.text = elem.codeNm
        return elem
      }).sort((a, b) => {
        if (a.code < b.code) { return -1 }
        if (a.code > b.code) { return 1 }
        return 0
      })
    },
    // 控除項目単価（画面表示用に整形）
    filteredKoujoKomokuTanka () {
      var array = this.filteredKoujoKomokuTankaWk
      var result = []
      var list = {}
      for (var i = 0; i <= Math.floor((array.length - 1) / 2); i++) {
        list = {}
        list.lists = array.slice(i * 2, i * 2 + 2)
        result.push(list)
      }
      return result
    },
    /* --------------------
      DdDropDown
    -------------------- */
    // 人員マスタ.性別
    filteredSeibetsuKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF001')
    },
    // 人員マスタ.血液型区分
    filteredKetsuekigataKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF002')
    },
    // 人員マスタ.血液型RH
    filteredKetsuekigataRh () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT001')
    },
    // 運転免許情報マスタ.種類
    filteredMenkyoShuruiKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF022')
    },
    // 住居情報マスタ.住居種別
    filteredJukyoSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF024')
    },
    // 家族情報マスタ.続柄
    filteredZokugara () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF003')
    },
    // 家族情報マスタ.同居
    filteredDoukyoKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFFK03')
    },
    // 家族情報マスタ.扶養
    filteredHuyouKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFFK04')
    },
    // 家族情報マスタ.障害者
    filteredKazokuShogaishaKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFFK05')
    },
    // 家族情報マスタ.健保扶養
    filteredKenpoHuyouKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFFK06')
    },
    // 人員マスタ.所得税計算区分
    filteredShotokuzeiKeisanKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF093')
    },
    // 人員マスタ.給与体系区分
    filteredKyuyoTaikeiKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF094')
    },
    // 人員マスタ.雇用保険計算方法区分
    filteredKoyouHokenKeisanKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF095')
    },
    // 人員マスタ.職種種別
    filteredShokushuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF021')
    },
    // 人事変更マスタ.人事変更種別
    filteredJinjiHenkoSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF026')
    },
    // 経歴情報マスタ.車検証自動車種別
    filteredShakenshoSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF023')
    },
    // 適性診断マスタ.適性診断受診種別
    filteredJushinSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF025')
    },
    // 事故歴マスタ.事故責任区分
    filteredJikoSekininKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF041')
    },
    // 特別教育マスタ.実施状況区分
    filteredJishiJokyoKbn () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF044')
    },
    // 人員マスタ.退職事由種別
    filteredTaishokuJiyuuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SFF042')
    },
    // 人員マスタ.乗務員種別
    filteredJomuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT005')
    },
    /* --------------------
      各マスタ項目必須判定
        関連の入力項目に値があればすべて必須属性化
    -------------------- */
    // 運転免許情報マスタ
    isRequiredMstMenkyosho () {
      if (this.rec.mstMenkyosho.length === 0) { return false }
      if (this.checkInput(this.rec.menkyoshoNo)) { return true }
      if (this.checkInput(this.rec.menkyoShuruiKbn)) { return true }
      if (this.checkInput(this.rec.menkyoJoken)) { return true }
      if (this.checkInput(this.rec.shutokuYmdString)) { return true }
      if (this.rec.mstMenkyosho !== undefined) {
        for (var i of this.rec.mstMenkyosho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.yukokigenString)) { return true }
          if (this.checkInput(i.yukoMenkyoshoNo)) { return true }
        }
      }
      return false
    },
    // 家族情報マスタ
    isRequiredMstKazokuJoho () {
      if (this.rec.mstKazokuJoho !== undefined) {
        for (var i of this.rec.mstKazokuJoho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.familyNmSei)) { return true }
          if (this.checkInput(i.familyNmMei)) { return true }
          if (this.checkInput(i.familySeinengappiString)) { return true }
          if (this.checkInput(i.zokugara)) { return true }
          if (this.checkInput(i.doukyoKbn)) { return true }
          if (this.checkInput(i.huyouKbn)) { return true }
          if (this.checkInput(i.kazokuShogaishaKbn)) { return true }
          if (this.checkInput(i.kenpoHuyouKbn)) { return true }
        }
      }
      return false
    },
    // 人事変更マスタ
    isRequiredMstJinjiHenko () {
      if (this.rec.mstJinjiHenko !== undefined) {
        for (var i of this.rec.mstJinjiHenko) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.jinjiHenkoSbt)) { return true }
          if (this.checkInput(i.henkoNaiyo)) { return true }
          if (this.checkInput(i.henkoYmdString)) { return true }
          if (this.checkInput(i.henkoRiyu)) { return true }
        }
      }
      return false
    },
    // 履歴情報マスタ
    isRequiredMstRirekiJoho () {
      if (this.rec.mstRirekiJoho !== undefined) {
        for (var i of this.rec.mstRirekiJoho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.rirekiYmdString)) { return true }
          if (this.checkInput(i.rirekiNaiyo)) { return true }
        }
      }
      return false
    },
    // 経歴情報マスタ
    isRequiredMstKeirekiJoho () {
      if (this.rec.mstKeirekiJoho !== undefined) {
        for (var i of this.rec.mstKeirekiJoho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.shakenshoSbt)) { return true }
          if (this.checkInput(i.teiinQty)) { return true }
          if (this.checkInput(i.sekisairyo)) { return true }
          if (this.checkInput(i.keikenYmYear)) { return true }
          if (this.checkInput(i.keikenYmMonth)) { return true }
          if (this.checkInput(i.jigyoshoNm)) { return true }
        }
      }
      return false
    },
    // 資格情報マスタ
    isRequiredMstShikakuJoho () {
      if (this.rec.mstShikakuJoho !== undefined) {
        for (var i of this.rec.mstShikakuJoho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.shikakuShutokuYmdString)) { return true }
          if (this.checkInput(i.shikakuNaiyo)) { return true }
        }
      }
      return false
    },
    // 賞罰情報マスタ
    isRequiredMstShobatsuJoho () {
      if (this.rec.mstShobatsuJoho !== undefined) {
        for (var i of this.rec.mstShobatsuJoho) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.shobatsuYmdString)) { return true }
          if (this.checkInput(i.shobatsuNaiyo)) { return true }
        }
      }
      return false
    },
    // 適性診断マスタ
    isRequiredMstTekiseiShindan () {
      if (this.rec.mstTekiseiShindan !== undefined) {
        for (var i of this.rec.mstTekiseiShindan) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.jushinSbt)) { return true }
          if (this.checkInput(i.jishiYmdString)) { return true }
          if (this.checkInput(i.jishiKikanNm)) { return true }
          if (this.checkInput(i.shokenTekiyo)) { return true }
        }
      }
      return false
    },
    // 事故歴マスタ
    isRequiredMstJikoreki () {
      if (this.rec.mstJikoreki !== undefined) {
        for (var i of this.rec.mstJikoreki) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.haseiYmdString)) { return true }
          if (this.checkInput(i.torokuNo)) { return true }
          if (this.checkInput(i.jikoNaiyo)) { return true }
          if (this.checkInput(i.jikoSekininKbn)) { return true }
          if (this.checkInput(i.jikoKirokuboNo)) { return true }
          if (this.checkInput(i.gaiyo)) { return true }
          if (this.checkInput(i.shisha)) { return true }
          if (this.checkInput(i.hushosha)) { return true }
          if (i.jikoFlg === true) { return true }
        }
      }
      return false
    },
    // 違反歴マスタ
    isRequiredMstIhanreki () {
      if (this.rec.mstIhanreki !== undefined) {
        for (var i of this.rec.mstIhanreki) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.ihanYmdString)) { return true }
          if (this.checkInput(i.ihanNaiyo)) { return true }
        }
      }
      return false
    },
    // 特別教育マスタ
    isRequiredMstTokubetsuKyoiku () {
      if (this.rec.mstTokubetsuKyoiku !== undefined) {
        for (var i of this.rec.mstTokubetsuKyoiku) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.jishiYmdString)) { return true }
          if (this.checkInput(i.jishiJokyoKbn)) { return true }
          if (this.checkInput(i.jishiNaiyo)) { return true }
        }
      }
      return false
    },
    // 健康診断マスタ
    isRequiredMstKenkoShindan () {
      if (this.rec.mstKenkoShindan !== undefined) {
        for (var i of this.rec.mstKenkoShindan) {
          if (i.id !== -1) { return true }
          if (this.checkInput(i.jishiYmdString)) { return true }
          if (this.checkInput(i.jishiKikanNm)) { return true }
          if (this.checkInput(i.shokenTekiyo)) { return true }
        }
      }
      return false
    },
    isDeleteDisable () {
      return this.id === 0
    },
    /* --------------------
      権限制御、表示モード別項目制御
    -------------------- */
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isPhotoDeleteButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isPhotoRegistButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isPasswordRegistButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    calcJuryoIntegerDigit () {
      if (this.kihonJohoList[0].juryoNumericLen) {
        return this.kihonJohoList[0].juryoNumericLen
      } else {
        return 10
      }
    },
    calcJuryoMinorDigit () {
      if (this.kihonJohoList[0].juryoDecimalLen) {
        return this.kihonJohoList[0].juryoDecimalLen
      } else {
        return 4
      }
    },
    calcJuryoMax () {
      return Math.pow(10, this.calcJuryoIntegerDigit) - Math.pow(10, -1 * this.calcJuryoMinorDigit)
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    /* --------------------
      パスワード変更ポップアップ
    -------------------- */
    checkPassword: function (password) {
      return new Promise((resolve) => {
        var condition = {
          password: password
        }
        this.HttpClient
          .post(`/api/v1/mstJinin/checkPassword?id=${this.id}`, condition)
          .then((data) => {
            if (data.payload) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
      })
    },
    validatePasswordRegist: function () {
      // 検証処理（個別実行）
      if (!this.validatePrivate(this.$refs.loginLockFlg)) { return false }
      if (!this.password.loginLockFlg) {
        // ログイン許可時のみチェックを実施
        if (!this.validatePrivate(this.$refs.passwordCurrent)) { return false }
        if (!this.validatePrivate(this.$refs.passwordNew)) { return false }
        if (!this.validatePrivate(this.$refs.passwordAgain)) { return false }
        if (!this.validatePrivate(this.$refs.riyouStartYmdString)) { return false }
        if (!this.validatePrivate(this.$refs.riyouEndYmdString)) { return false }
      }
      // 検証処理
      // 適用年月日の大小チェック
      var msg = validators.compareDate(this.password.riyouStartYmdString, this.password.riyouEndYmdString)
      if (msg !== undefined) {
        this.$refs.riyouStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.riyouEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      // 現在のパスワード入力チェック（修正時のみ）
      if (this.passwordCurrentDisp === true && this.password.passwordCurrent.length === 0) {
        this.$refs.passwordCurrent[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGEREQUIREPASSWORD)
        return false
      }
      // 新パスワードの同一チェック（入力時のみ）
      if (this.password.passwordNew.length !== 0 && this.password.passwordNew !== this.password.passwordAgain) {
        this.$refs.passwordNew[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGECHECKPASSWORD)
        this.$refs.passwordAgain[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGECHECKPASSWORD)
        return false
      }

      return true
    },
    onPasswordRegistButtonClick: function () {
      // パスワード変更ポップアップの検証処理を実行
      if (this.validatePasswordRegist()) {
        if (this.passwordCurrentDisp === true) {
          return new Promise((resolve) => {
            this.checkPassword(this.password.passwordCurrent)
              .then((data) => {
                if (data === false) {
                  this.$refs.passwordCurrent[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGECHECKPASSWORD)
                  return resolve()
                }
                // 設定値を退避
                this.passwordClone = JSON.parse(JSON.stringify(this.password))
                // 更新データを設定
                this.rec.mstJinin.loginLockFlg = this.password.loginLockFlg
                this.rec.mstJinin.riyouStartYmdString = this.password.riyouStartYmdString
                this.rec.mstJinin.riyouEndYmdString = this.password.riyouEndYmdString
                // 更新データを設定（パスワード）
                if (this.password.passwordNew.length !== 0) {
                  this.rec.mstJinin.password = this.password.passwordNew
                  this.rec.passwordRegistFlg = true
                }
                // ダイアログを閉じる
                this.password_regist = false
                resolve()
              })
          })
        } else {
          if (!this.password.loginLockFlg && this.password.passwordNew.length === 0) {
            this.$refs.passwordNew[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGEREQUIREPASSWORD)
            return
          }
          // 設定値を退避
          this.passwordClone = JSON.parse(JSON.stringify(this.password))
          // 更新データを設定
          this.rec.mstJinin.loginLockFlg = this.password.loginLockFlg
          this.rec.mstJinin.riyouStartYmdString = this.password.riyouStartYmdString
          this.rec.mstJinin.riyouEndYmdString = this.password.riyouEndYmdString
          // 更新データを設定（パスワード）
          if (this.password.passwordNew.length !== 0) {
            this.rec.mstJinin.password = this.password.passwordNew
            this.rec.passwordRegistFlg = true
          }
          // ダイアログを閉じる
          this.password_regist = false
        }
      }
    },
    onPasswordRegistCloseButtonClick: function () {
      if (this.isShoukaiMode !== true) {
        // 退避済設定値を反映
        this.password = JSON.parse(JSON.stringify(this.passwordClone))
      }
      // ダイアログを閉じる
      this.password_regist = false
    },
    /* --------------------
      写真登録ポップアップ
    -------------------- */
    checkPhoto: function (faceImage) {
      return new Promise((resolve) => {
        this.HttpClient
          .post('/api/v1/mstFaceImage/checkPhoto', { faceImage: faceImage })
          .then((data) => {
            if (data.payload) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
      })
    },
    // アップロード時changeイベント
    onImagePicked: function (file) {
      if (file === undefined || file === null) {
        this.photo.faceImage = null
        return
      }
      // 画像ファイル判断（MIMEタイプが'image/*'で画像ファイルと判断）
      if (file.type.indexOf('image/') !== 0) {
        this.photo.faceImage = null
        this.$refs.imagePicked[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGEIMAGEPICKED)
        return
      }
      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.photo.faceImage = fr.result
      })
    },
    validatePhotoRegist: function () {
      // 検証処理（個別実行）
      if (!this.validatePrivate(this.$refs.imagePicked)) { return false }
      // 写真アップロード確認
      if (this.photo.faceImage.length === 0) {
        this.$refs.imagePicked[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGEIMAGEPICKED)
        return false
      }
      if (!this.validatePrivate(this.$refs.satsueiYmYear)) { return false }
      if (!this.validatePrivate(this.$refs.satsueiYmMonth)) { return false }
      // 検証処理
      var msg = ''
      // 年の範囲チェック
      if (this.photo.satsueiYmYear !== null) {
        if (this.photo.satsueiYmYear.length !== 0) {
          msg = validators.numericalRangeValidate({ value: this.photo.satsueiYmYear, max: 2999, min: 1900 })
          if (msg !== undefined) {
            this.$refs.satsueiYmYear[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      // 月の範囲チェック
      if (this.photo.satsueiYmMonth !== null) {
        if (this.photo.satsueiYmMonth.length !== 0) {
          msg = validators.numericalRangeValidate({ value: this.photo.satsueiYmMonth, max: 12, min: 1 })
          if (msg !== undefined) {
            this.$refs.satsueiYmMonth[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }

      return true
    },
    onPhotoRegistButtonClick: function () {
      // 写真登録ポップアップの検証処理を実行
      if (this.validatePhotoRegist() === true) {
        this.checkPhoto(this.photo.faceImage)
          .then((data) => {
            if (data) {
              // 設定値を退避
              this.photoClone = JSON.parse(JSON.stringify(this.photo))
              // 更新データを設定
              this.rec.mstJinin.satsueiYmYear = this.photo.satsueiYmYear
              this.rec.mstJinin.satsueiYmMonth = this.photo.satsueiYmMonth
              this.rec.mstFaceImage.faceImage = this.photo.faceImage
              this.rec.photoDeleteFlg = false
              // ダイアログを閉じる
              this.photo_regist = false
            } else {
              this.$refs.imagePicked[this.Ctrls.SET_INVALID_METHOD](ERRORMESSAGEIMAGEPICKED)
            }
          })
      }
    },
    onPhotoDeleteButtonClick: function () {
      this.photo.imagePicked = null
      this.photo.satsueiYmYear = null
      this.photo.satsueiYmMonth = null
      this.photo.faceImage = null
      // 更新データを設定
      this.rec.mstJinin.satsueiYmYear = this.photo.satsueiYmYear
      this.rec.mstJinin.satsueiYmMonth = this.photo.satsueiYmMonth
      this.rec.mstFaceImage.faceImage = this.photo.faceImage
      this.rec.photoDeleteFlg = true
      // 設定値を退避
      this.photoClone = JSON.parse(JSON.stringify(this.photo))
      // ダイアログを閉じる
      this.photo_regist = false
    },
    onPhotoRegistCloseButtonClick: function () {
      if (this.isShoukaiMode !== true) {
        // 退避済設定値を反映
        this.photo = JSON.parse(JSON.stringify(this.photoClone))
      }
      // ダイアログを閉じる
      this.photo_regist = false
    },
    /* --------------------
      各マスタ項目入力確認
    -------------------- */
    checkInput: function (col) {
      if (![undefined, null].includes(col)) {
        if (col.length !== 0) {
          return true
        }
      }
      return false
    },
    /* --------------------
      運転免許情報マスタ
    -------------------- */
    onAddMstMenkyoshoClick: function () {
      HYOJIORDERMSTMENKYOSHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTMENKYOSHO
      row.yukokigenString = ''
      row.yukoMenkyoshoNo = ''
      this.rec.mstMenkyosho.push(row)
    },
    onDeleteMstMenkyoshoClick: function (index) {
      this.rec.mstMenkyoshoDel.push(this.rec.mstMenkyosho[index])
      this.rec.mstMenkyosho.splice(index, 1)
    },
    /* --------------------
      家族情報マスタ
    -------------------- */
    onAddMstKazokuJohoClick: function () {
      HYOJIORDERMSTKAZOKUJOHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTKAZOKUJOHO
      row.familyNmSei = ''
      row.familyNmMei = ''
      row.familySeinengappiString = ''
      row.zokugara = ''
      row.doukyoKbn = null
      row.huyouKbn = null
      row.kazokuShogaishaKbn = null
      row.kenpoHuyouKbn = null
      this.rec.mstKazokuJoho.push(row)
    },
    onDeleteMstKazokuJohoClick: function (index) {
      this.rec.mstKazokuJohoDel.push(this.rec.mstKazokuJoho[index])
      this.rec.mstKazokuJoho.splice(index, 1)
    },
    /* --------------------
      人事変更マスタ
    -------------------- */
    onAddMstJinjiHenkoClick: function () {
      HYOJIORDERMSTJINJIHENKO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTJINJIHENKO
      row.jinjiHenkoSbt = ''
      row.henkoNaiyo = ''
      row.henkoYmdString = ''
      row.henkoRiyu = ''
      this.rec.mstJinjiHenko.push(row)
    },
    onDeleteMstJinjiHenkoClick: function (index) {
      this.rec.mstJinjiHenkoDel.push(this.rec.mstJinjiHenko[index])
      this.rec.mstJinjiHenko.splice(index, 1)
    },
    /* --------------------
      履歴情報マスタ
    -------------------- */
    onAddMstRirekiJohoClick: function () {
      HYOJIORDERMSTRIREKIJOHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTRIREKIJOHO
      row.rirekiYmdString = ''
      row.rirekiNaiyo = ''
      this.rec.mstRirekiJoho.push(row)
    },
    onDeleteMstRirekiJohoClick: function (index) {
      this.rec.mstRirekiJohoDel.push(this.rec.mstRirekiJoho[index])
      this.rec.mstRirekiJoho.splice(index, 1)
    },
    /* --------------------
      経歴情報マスタ
    -------------------- */
    onAddMstKeirekiJohoClick: function () {
      HYOJIORDERMSTKEIREKIJOHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTKEIREKIJOHO
      row.shakenshoSbt = ''
      row.teiinQty = ''
      row.sekisairyo = ''
      row.keikenYmYear = ''
      row.keikenYmMonth = ''
      row.jigyoshoNm = ''
      this.rec.mstKeirekiJoho.push(row)
    },
    onDeleteMstKeirekiJohoClick: function (index) {
      this.rec.mstKeirekiJohoDel.push(this.rec.mstKeirekiJoho[index])
      this.rec.mstKeirekiJoho.splice(index, 1)
    },
    /* --------------------
      資格情報マスタ
    -------------------- */
    onAddMstShikakuJohoClick: function () {
      HYOJIORDERMSTSHIKAKUJOHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTSHIKAKUJOHO
      row.shikakuShutokuYmdString = ''
      row.shikakuNaiyo = ''
      this.rec.mstShikakuJoho.push(row)
    },
    onDeleteMstShikakuJohoClick: function (index) {
      this.rec.mstShikakuJohoDel.push(this.rec.mstShikakuJoho[index])
      this.rec.mstShikakuJoho.splice(index, 1)
    },
    /* --------------------
      賞罰情報マスタ
    -------------------- */
    onAddMstShobatsuJohoClick: function () {
      HYOJIORDERMSTSHOBATSUJOHO += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTSHOBATSUJOHO
      row.shobatsuYmdString = ''
      row.shobatsuNaiyo = ''
      this.rec.mstShobatsuJoho.push(row)
    },
    onDeleteMstShobatsuJohoClick: function (index) {
      this.rec.mstShobatsuJohoDel.push(this.rec.mstShobatsuJoho[index])
      this.rec.mstShobatsuJoho.splice(index, 1)
    },
    /* --------------------
      適性診断マスタ
    -------------------- */
    onAddMstTekiseiShindanClick: function () {
      HYOJIORDERMSTTEKISEISHINDAN += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTTEKISEISHINDAN
      row.jushinSbt = null
      row.jishiYmdString = ''
      row.jishiKikanNm = ''
      row.shokenTekiyo = ''
      this.rec.mstTekiseiShindan.push(row)
    },
    onDeleteMstTekiseiShindanClick: function (index) {
      this.rec.mstTekiseiShindanDel.push(this.rec.mstTekiseiShindan[index])
      this.rec.mstTekiseiShindan.splice(index, 1)
    },
    /* --------------------
      事故歴マスタ
    -------------------- */
    onAddMstJikorekiClick: function () {
      HYOJIORDERMSTJIKOREKI += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTJIKOREKI
      row.haseiYmdString = ''
      row.torokuNo = ''
      row.jikoNaiyo = ''
      row.jikoSekininKbn = null
      row.jikoKirokuboNo = ''
      row.gaiyo = ''
      row.jikoFlg = false
      row.shisha = ''
      row.hushosha = ''
      this.rec.mstJikoreki.push(row)
    },
    onDeleteMstJikorekiClick: function (index) {
      this.rec.mstJikorekiDel.push(this.rec.mstJikoreki[index])
      this.rec.mstJikoreki.splice(index, 1)
    },
    /* --------------------
      違反歴マスタ
    -------------------- */
    onAddMstIhanrekiClick: function () {
      HYOJIORDERMSTIHANREKI += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTIHANREKI
      row.ihanYmdString = ''
      row.ihanNaiyo = ''
      this.rec.mstIhanreki.push(row)
    },
    onDeleteMstIhanrekiClick: function (index) {
      this.rec.mstIhanrekiDel.push(this.rec.mstIhanreki[index])
      this.rec.mstIhanreki.splice(index, 1)
    },
    /* --------------------
      特別教育マスタ
    -------------------- */
    onAddMstTokubetsuKyoikuClick: function () {
      HYOJIORDERMSTTOKUBETSUKYOIKU += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTTOKUBETSUKYOIKU
      row.jishiYmdString = ''
      row.jishiJokyoKbn = null
      row.jishiNaiyo = ''
      this.rec.mstTokubetsuKyoiku.push(row)
    },
    onDeleteMstTokubetsuKyoikuClick: function (index) {
      this.rec.mstTokubetsuKyoikuDel.push(this.rec.mstTokubetsuKyoiku[index])
      this.rec.mstTokubetsuKyoiku.splice(index, 1)
    },
    /* --------------------
      健康診断マスタ
    -------------------- */
    onAddMstKenkoShindanClick: function () {
      HYOJIORDERMSTKENKOSHINDAN += 1
      var row = {}
      row.id = -1
      row.hyojiOrder = HYOJIORDERMSTKENKOSHINDAN
      row.jishiYmdString = ''
      row.jishiKikanNm = ''
      row.shokenTekiyo = ''
      this.rec.mstKenkoShindan.push(row)
    },
    onDeleteMstKenkoShindanClick: function (index) {
      this.rec.mstKenkoShindanDel.push(this.rec.mstKenkoShindan[index])
      this.rec.mstKenkoShindan.splice(index, 1)
    },
    /* --------------------
      検証処理（個別実行）
    -------------------- */
    validatePrivate: function (ref) {
      if (ref[this.Ctrls.VALIDATE_METHOD] === undefined) { return }
      if (ref[this.Ctrls.GET_INVALID_METHOD] === undefined) { return }
      ref[this.Ctrls.VALIDATE_METHOD]()
      var res = ref[this.Ctrls.GET_INVALID_METHOD]()
      return res === undefined
    },
    /* --------------------
      日付フォーマット（存在、空白考慮）
    -------------------- */
    dateformatPrivate: function (date) {
      if (date !== undefined && date !== null) {
        if (date.length !== 0) {
          return filter.dateFormatter(date)
        }
      }
      return date
    },
    /* --------------------
      利用終了年月日を設定（デフォルト期間）
    -------------------- */
    setRiyouEndYmdString: function (riyouStartYmdString) {
      if (this.filterRiyoKikan.length === 0) { return riyouStartYmdString }
      var result = ''
      var dt = new Date(riyouStartYmdString)
      // 計算前日付
      var beforeDate = dt.getDate()
      dt.setMonth(dt.getMonth() + Number(this.filterRiyoKikan))
      if (dt.getDate() !== beforeDate) {
        // 計算後日付が一致しない場合、前月月末指定
        result = filter.dateFormatter(dt.setDate(0))
      } else {
        result = filter.dateFormatter(dt)
      }
      return result
    },
    /* --------------------
      共通処理
    -------------------- */
    getCloneTargetMethod: function () {
      console.log('★★★getCloneTargetMethod★★★')
      console.log(this.rec)
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      console.log('★★★beforeRouteLeaveByMenu★★★')
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        self.HttpClient
          .post(`/api/v1/vwCMstJinin/searchChildren?id=${self.id}`)
          .then((data) => {
            if (data.payload) {
              /* --------------------
                人員マスタ
              -------------------- */
              self.rec.mstJinin = data.payload.mstJinin
              // 日付項目を削除（日付文字列化項目を使用）
              delete self.rec.mstJinin.tekiyoStartYmd
              delete self.rec.mstJinin.tekiyoEndYmd
              delete self.rec.mstJinin.seinengappi
              delete self.rec.mstJinin.kenkoHokenKanyuYmd
              delete self.rec.mstJinin.koseiNenkinKanyuYmd
              delete self.rec.mstJinin.koseiKikinKanyuYmd
              delete self.rec.mstJinin.koyoHokenKanyuYmd
              delete self.rec.mstJinin.rosaiHokenKanyuYmd
              delete self.rec.mstJinin.yatoiireYmd
              delete self.rec.mstJinin.senninYmd
              delete self.rec.mstJinin.kaininYmd
              delete self.rec.mstJinin.taishokuYmd
              delete self.rec.mstJinin.riyouStartYmd
              delete self.rec.mstJinin.riyouEndYmd
              // 日付項目の設定（NULLを考慮）
              if (!self.rec.mstJinin.tekiyoStartYmdString) {
                self.rec.mstJinin.tekiyoStartYmdString = ''
              }
              if (!self.rec.mstJinin.tekiyoEndYmdString) {
                self.rec.mstJinin.tekiyoEndYmdString = ''
              }
              if (!self.rec.mstJinin.seinengappiString) {
                self.rec.mstJinin.seinengappiString = ''
              }
              if (!self.rec.mstJinin.kenkoHokenKanyuYmdString) {
                self.rec.mstJinin.kenkoHokenKanyuYmdString = ''
              }
              if (!self.rec.mstJinin.koseiNenkinKanyuYmdString) {
                self.rec.mstJinin.koseiNenkinKanyuYmdString = ''
              }
              if (!self.rec.mstJinin.koseiKikinKanyuYmdString) {
                self.rec.mstJinin.koseiKikinKanyuYmdString = ''
              }
              if (!self.rec.mstJinin.koyoHokenKanyuYmdString) {
                self.rec.mstJinin.koyoHokenKanyuYmdString = ''
              }
              if (!self.rec.mstJinin.rosaiHokenKanyuYmdString) {
                self.rec.mstJinin.rosaiHokenKanyuYmdString = ''
              }
              if (!self.rec.mstJinin.yatoiireYmdString) {
                self.rec.mstJinin.yatoiireYmdString = ''
              }
              if (!self.rec.mstJinin.senninYmdString) {
                self.rec.mstJinin.senninYmdString = ''
              }
              if (!self.rec.mstJinin.kaininYmdString) {
                self.rec.mstJinin.kaininYmdString = ''
              }
              if (!self.rec.mstJinin.taishokuYmdString) {
                self.rec.mstJinin.taishokuYmdString = ''
              }
              if (!self.rec.mstJinin.riyouStartYmdString) {
                self.rec.mstJinin.riyouStartYmdString = ''
              }
              if (!self.rec.mstJinin.riyouEndYmdString) {
                self.rec.mstJinin.riyouEndYmdString = ''
              }
              // 入力項目動的DOM用に値を設定（支給項目単価）
              self.rec.shikyuKomokuTanka = data.payload.mstJinin
              // 入力項目動的DOM用に値を設定（控除項目単価）
              self.rec.koujoKomokuTanka = data.payload.mstJinin
              // DdDropDownの設定（NULLを考慮）
              if (!self.rec.mstJinin.seibetsuKbn) {
                self.rec.mstJinin.seibetsuKbn = null
              }
              if (!self.rec.mstJinin.ketsuekigataKbn) {
                self.rec.mstJinin.ketsuekigataKbn = null
              }
              if (!self.rec.mstJinin.ketsuekigataRh) {
                self.rec.mstJinin.ketsuekigataRh = null
              }
              if (!self.rec.mstJinin.shotokuzeiKeisanKbn) {
                self.rec.mstJinin.shotokuzeiKeisanKbn = null
              }
              if (!self.rec.mstJinin.kyuyoTaikeiKbn) {
                self.rec.mstJinin.kyuyoTaikeiKbn = null
              }
              if (!self.rec.mstJinin.koyouHokenKeisanKbn) {
                self.rec.mstJinin.koyouHokenKeisanKbn = null
              }
              if (!self.rec.mstJinin.shokushuSbt) {
                self.rec.mstJinin.shokushuSbt = null
              }
              if (!self.rec.mstJinin.taishokuJiyuuSbt) {
                self.rec.mstJinin.taishokuJiyuuSbt = null
              }
              /* --------------------
                パスワード変更ポップアップ
              -------------------- */
              self.password.loginLockFlg = data.payload.mstJinin.loginLockFlg
              self.password.riyouStartYmdString = data.payload.mstJinin.riyouStartYmdString
              self.password.riyouEndYmdString = data.payload.mstJinin.riyouEndYmdString
              // 設定値を退避
              self.passwordClone = JSON.parse(JSON.stringify(self.password))
              /* --------------------
                顔写真マスタ
              -------------------- */
              if (data.payload.mstFaceImage) {
                self.rec.mstFaceImage = data.payload.mstFaceImage
                /* --------------------
                  写真登録ポップアップ
                -------------------- */
                self.photo.satsueiYmYear = data.payload.mstJinin.satsueiYmYear
                self.photo.satsueiYmMonth = data.payload.mstJinin.satsueiYmMonth
                self.photo.faceImage = data.payload.mstFaceImage.faceImage
                // 設定値を退避
                self.photoClone = JSON.parse(JSON.stringify(self.photo))
              }
              /* --------------------
                住居情報マスタ
              -------------------- */
              if (data.payload.mstJukyoJoho) {
                self.rec.mstJukyoJoho = data.payload.mstJukyoJoho
                // DdDropDownの設定
                if (!self.rec.mstJukyoJoho.jukyoSbt) {
                  self.rec.mstJinin.jukyoSbt = null
                }
              }
              /* --------------------
                運転免許情報マスタ
              -------------------- */
              if (data.payload.mstMenkyosho.length !== 0) {
                self.rec.mstMenkyosho = data.payload.mstMenkyosho
                // DdDropDownの設定
                if (!self.rec.mstMenkyosho.menkyoShuruiKbn) {
                  self.rec.mstJinin.jukyoSbt = ''
                }
                // 各レコードの共通項目を先頭行から取得（フォーマット）
                self.rec.menkyoshoNo = data.payload.mstMenkyosho[0].menkyoshoNo
                if (!self.rec.mstMenkyosho[0].menkyoShuruiKbn) {
                  self.rec.menkyoShuruiKbn = ''
                } else {
                  self.rec.menkyoShuruiKbn = data.payload.mstMenkyosho[0].menkyoShuruiKbn
                }
                self.rec.menkyoJoken = data.payload.mstMenkyosho[0].menkyoJoken
                self.rec.shutokuYmdString = data.payload.mstMenkyosho[0].shutokuYmdString

                self.rec.mstMenkyosho = self.rec.mstMenkyosho.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.shutokuYmd
                  delete elem.yukokigen
                  // 日付項目の設定
                  if (!elem.shutokuYmdString) {
                    elem.shutokuYmdString = ''
                  }
                  if (!elem.yukokigenString) {
                    elem.yukokigenString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTMENKYOSHO = Math.max.apply(null, self.rec.mstMenkyosho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                家族情報マスタ
              -------------------- */
              if (data.payload.mstKazokuJoho.length !== 0) {
                self.rec.mstKazokuJoho = data.payload.mstKazokuJoho

                self.rec.mstKazokuJoho = self.rec.mstKazokuJoho.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.familySeinengappi
                  // 日付項目の設定
                  if (!elem.familySeinengappiString) {
                    elem.familySeinengappiString = ''
                  }
                  // DdDropDownの設定
                  if (!elem.zokugara) {
                    elem.zokugara = ''
                  }
                  if (!elem.doukyoKbn) {
                    elem.doukyoKbn = null
                  }
                  if (!elem.huyouKbn) {
                    elem.huyouKbn = null
                  }
                  if (!elem.kazokuShogaishaKbn) {
                    elem.kazokuShogaishaKbn = null
                  }
                  if (!elem.kenpoHuyouKbn) {
                    elem.kenpoHuyouKbn = null
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTKAZOKUJOHO = Math.max.apply(null, self.rec.mstKazokuJoho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                人事変更マスタ
              -------------------- */
              if (data.payload.mstJinjiHenko.length !== 0) {
                self.rec.mstJinjiHenko = data.payload.mstJinjiHenko

                self.rec.mstJinjiHenko = self.rec.mstJinjiHenko.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.henkoYmd
                  // 日付項目の設定
                  if (!elem.henkoYmdString) {
                    elem.henkoYmdString = ''
                  }
                  // DdDropDownの設定
                  if (!elem.jinjiHenkoSbt) {
                    elem.jinjiHenkoSbt = null
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTJINJIHENKO = Math.max.apply(null, self.rec.mstJinjiHenko.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                履歴情報マスタ
              -------------------- */
              if (data.payload.mstRirekiJoho.length !== 0) {
                self.rec.mstRirekiJoho = data.payload.mstRirekiJoho

                self.rec.mstRirekiJoho = self.rec.mstRirekiJoho.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.rirekiYmd
                  // 日付項目の設定
                  if (!elem.rirekiYmdString) {
                    elem.rirekiYmdString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTRIREKIJOHO = Math.max.apply(null, self.rec.mstRirekiJoho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                経歴情報マスタ
              -------------------- */
              if (data.payload.mstKeirekiJoho.length !== 0) {
                self.rec.mstKeirekiJoho = data.payload.mstKeirekiJoho

                self.rec.mstKeirekiJoho = self.rec.mstKeirekiJoho.map((elem) => {
                  // DdDropDownの設定
                  if (!elem.shakenshoSbt) {
                    elem.shakenshoSbt = null
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTKEIREKIJOHO = Math.max.apply(null, self.rec.mstKeirekiJoho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                資格情報マスタ
              -------------------- */
              if (data.payload.mstShikakuJoho.length !== 0) {
                self.rec.mstShikakuJoho = data.payload.mstShikakuJoho

                self.rec.mstShikakuJoho = self.rec.mstShikakuJoho.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.shikakuShutokuYmd
                  // 日付項目の設定
                  if (!elem.shikakuShutokuYmdString) {
                    elem.shikakuShutokuYmdString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTSHIKAKUJOHO = Math.max.apply(null, self.rec.mstShikakuJoho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                賞罰情報マスタ
              -------------------- */
              if (data.payload.mstShobatsuJoho.length !== 0) {
                self.rec.mstShobatsuJoho = data.payload.mstShobatsuJoho

                self.rec.mstShobatsuJoho = self.rec.mstShobatsuJoho.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.shobatsuYmd
                  // 日付項目の設定
                  if (!elem.shobatsuYmdString) {
                    elem.shobatsuYmdString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTSHOBATSUJOHO = Math.max.apply(null, self.rec.mstShobatsuJoho.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                適性診断マスタ
              -------------------- */
              if (data.payload.mstTekiseiShindan.length !== 0) {
                self.rec.mstTekiseiShindan = data.payload.mstTekiseiShindan

                self.rec.mstTekiseiShindan = self.rec.mstTekiseiShindan.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.jishiYmd
                  // 日付項目の設定
                  if (!elem.jishiYmdString) {
                    elem.jishiYmdString = ''
                  }
                  // DdDropDownの設定
                  if (!elem.jushinSbt) {
                    elem.jushinSbt = null
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTTEKISEISHINDAN = Math.max.apply(null, self.rec.mstTekiseiShindan.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                事故歴マスタ
              -------------------- */
              if (data.payload.mstJikoreki.length !== 0) {
                self.rec.mstJikoreki = data.payload.mstJikoreki

                self.rec.mstJikoreki = self.rec.mstJikoreki.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.haseiYmd
                  // 日付項目の設定
                  if (!elem.haseiYmdString) {
                    elem.haseiYmdString = ''
                  }
                  // DdDropDownの設定
                  if (!elem.jikoSekininKbn) {
                    elem.jikoSekininKbn = null
                  }
                  // 数値項目の設定（nullで登録されることがある）
                  if (elem.shisha === null) {
                    elem.shisha = ''
                  }
                  if (elem.hushosha === null) {
                    elem.hushosha = ''
                  }

                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTJIKOREKI = Math.max.apply(null, self.rec.mstJikoreki.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                違反歴マスタ
              -------------------- */
              if (data.payload.mstIhanreki.length !== 0) {
                self.rec.mstIhanreki = data.payload.mstIhanreki

                self.rec.mstIhanreki = self.rec.mstIhanreki.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.ihanYmd
                  // 日付項目の設定
                  if (!elem.ihanYmdString) {
                    elem.ihanYmdString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTIHANREKI = Math.max.apply(null, self.rec.mstIhanreki.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                特別教育マスタ
              -------------------- */
              if (data.payload.mstTokubetsuKyoiku.length !== 0) {
                self.rec.mstTokubetsuKyoiku = data.payload.mstTokubetsuKyoiku

                self.rec.mstTokubetsuKyoiku = self.rec.mstTokubetsuKyoiku.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.jishiYmd
                  // 日付項目の設定
                  if (!elem.jishiYmdString) {
                    elem.jishiYmdString = ''
                  }
                  // DdDropDownの設定
                  if (!elem.jishiJokyoKbn) {
                    elem.jishiJokyoKbn = null
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTTOKUBETSUKYOIKU = Math.max.apply(null, self.rec.mstTokubetsuKyoiku.map(function (e) { return e.hyojiOrder }))
              }
              /* --------------------
                健康診断マスタ
              -------------------- */
              if (data.payload.mstKenkoShindan.length !== 0) {
                self.rec.mstKenkoShindan = data.payload.mstKenkoShindan

                self.rec.mstKenkoShindan = self.rec.mstKenkoShindan.map((elem) => {
                  // 日付項目を削除（日付文字列化項目を使用）
                  delete elem.jishiYmd
                  // 日付項目の設定
                  if (!elem.jishiYmdString) {
                    elem.jishiYmdString = ''
                  }
                  return elem
                })
                // 表操作用に最大値保持
                HYOJIORDERMSTKENKOSHINDAN = Math.max.apply(null, self.rec.mstKenkoShindan.map(function (e) { return e.hyojiOrder }))
              }

              this.rec.mstJinin.color = [undefined, null, ''].includes(this.rec.mstJinin.color) ? '#b0bec5' : this.rec.mstJinin.color
              this.chipColorTmp = this.rec.mstJinin.color
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('★★★initialize★★★')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmstkengengroup01', 'mstshubetsu', 'msyskubun', 'msyssystemconfig', 'mstkihonjoho'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              // 入力項目動的DOM管理用（支給項目単価）
              shikyuKomokuTanka: {},
              // 入力項目動的DOM管理用（控除項目単価）
              koujoKomokuTanka: {},
              // 人員マスタ
              mstJinin: {
                eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
                kengenGroupCd: '',
                seibetsuKbn: null,
                ketsuekigataKbn: null,
                ketsuekigataRh: null,
                shokushuSbt: null,
                taishokuJiyuuSbt: null,
                unkoKanriFlg: false,
                jomuFlg: false,
                jomuSbt: null,
                taeigyoshoSousaKanouFlg: false,
                // 0: 計算不要
                shotokuzeiKeisanKbn: '0',
                // 1: 月給
                kyuyoTaikeiKbn: '1',
                // 01: 計算する
                koyouHokenKeisanKbn: '01',
                // 日付項目初期値
                tekiyoStartYmdString: '2000/01/01',
                tekiyoEndYmdString: '2100/01/01',
                seinengappiString: '',
                kenkoHokenKanyuYmdString: '',
                koseiNenkinKanyuYmdString: '',
                koseiKikinKanyuYmdString: '',
                koyoHokenKanyuYmdString: '',
                rosaiHokenKanyuYmdString: '',
                yatoiireYmdString: '',
                senninYmdString: '',
                kaininYmdString: '',
                taishokuYmdString: '',
                // システム日付
                riyouStartYmdString: filter.dateFormatter(new Date()),
                riyouEndYmdString: self.setRiyouEndYmdString(filter.dateFormatter(new Date())),
                hyojiOrder: '9999',
                // 未入力時は半角スペースで登録
                password: ' ',
                color: '#1E88E5'
              },
              // 顔写真マスタ
              mstFaceImage: {
                id: -1,
                faceImage: ''
              },
              mstFaceImageRegistFlg: true,
              // 住居情報マスタ
              mstJukyoJoho: { id: -1, jukyoSbt: null },
              // 運転免許情報マスタ
              mstMenkyosho: [{ id: -1, hyojiOrder: 1, yukokigenString: '', yukoMenkyoshoNo: '' }],
              mstMenkyoshoDel: [],
              mstMenkyoshoRegistFlg: true,
              // 運転免許情報マスタ 共通入力項目 外出し
              menkyoshoNo: '',
              menkyoShuruiKbn: null,
              menkyoJoken: '',
              shutokuYmdString: '',
              // 家族情報マスタ
              mstKazokuJoho: [{ id: -1, hyojiOrder: 1, familyNmSei: '', familyNmMei: '', familySeinengappiString: '', zokugara: '', doukyoKbn: '', huyouKbn: '', kazokuShogaishaKbn: '', kenpoHuyouKbn: '' }],
              mstKazokuJohoDel: [],
              mstKazokuJohoRegistFlg: true,
              // 人事変更マスタ
              mstJinjiHenko: [{ id: -1, hyojiOrder: 1, jinjiHenkoSbt: null, henkoNaiyo: '', henkoYmdString: '', henkoRiyu: '' }],
              mstJinjiHenkoDel: [],
              mstJinjiHenkoRegistFlg: true,
              // 履歴情報マスタ
              mstRirekiJoho: [{ id: -1, hyojiOrder: 1, rirekiYmdString: '', rirekiNaiyo: '' }],
              mstRirekiJohoDel: [],
              mstRirekiJohoRegistFlg: true,
              // 経歴情報マスタ
              mstKeirekiJoho: [{ id: -1, hyojiOrder: 1, shakenshoSbt: null, teiinQty: '', sekisairyo: '', keikenYmYear: '', keikenYmMonth: '', jigyoshoNm: '' }],
              mstKeirekiJohoDel: [],
              mstKeirekiJohoRegistFlg: true,
              // 資格情報マスタ
              mstShikakuJoho: [{ id: -1, hyojiOrder: 1, shikakuShutokuYmdString: '', shikakuNaiyo: '' }],
              mstShikakuJohoDel: [],
              mstShikakuJohoRegistFlg: true,
              // 賞罰情報マスタ
              mstShobatsuJoho: [{ id: -1, hyojiOrder: 1, shobatsuYmdString: '', shobatsuNaiyo: '' }],
              mstShobatsuJohoDel: [],
              mstShobatsuJohoRegistFlg: true,
              // 適性診断マスタ
              mstTekiseiShindan: [{ id: -1, hyojiOrder: 1, jushinSbt: null, jishiYmdString: '', jishiKikanNm: '', shokenTekiyo: '' }],
              mstTekiseiShindanDel: [],
              mstTekiseiShindanRegistFlg: true,
              // 事故歴マスタ
              mstJikoreki: [{ id: -1, hyojiOrder: 1, haseiYmdString: '', torokuNo: '', jikoNaiyo: '', jikoSekininKbn: null, jikoKirokuboNo: '', gaiyo: '', jikoFlg: false, shisha: '', hushosha: '' }],
              mstJikorekiDel: [],
              mstJikorekiRegistFlg: true,
              // 違反歴マスタ
              mstIhanreki: [{ id: -1, hyojiOrder: 1, ihanYmdString: '', ihanNaiyo: '' }],
              mstIhanrekiDel: [],
              mstIhanrekiRegistFlg: true,
              // 特別教育マスタ
              mstTokubetsuKyoiku: [{ id: -1, hyojiOrder: 1, jishiYmdString: '', jishiJokyoKbn: null, jishiNaiyo: '' }],
              mstTokubetsuKyoikuDel: [],
              mstTokubetsuKyoikuRegistFlg: true,
              // 健康診断マスタ
              mstKenkoShindan: [{ id: -1, hyojiOrder: 1, jishiYmdString: '', jishiKikanNm: '', shokenTekiyo: '' }],
              mstKenkoShindanDel: [],
              mstKenkoShindanRegistFlg: true,
              // パスワード更新フラグ
              passwordRegistFlg: false,
              // 顔写真削除フラグ
              photoDeleteFlg: false
            }
            // 写真登録ポップアップ
            self.photo = {
              imagePicked: null,
              satsueiYmYear: '',
              satsueiYmMonth: '',
              faceImage: ''
            }
            self.photoClone = JSON.parse(JSON.stringify(self.photo))
            // パスワード変更ポップアップ
            self.password = {
              passwordCurrent: '',
              loginLockFlg: false,
              passwordNew: '',
              passwordAgain: '',
              riyouStartYmdString: self.rec.mstJinin.riyouStartYmdString,
              riyouEndYmdString: self.rec.mstJinin.riyouEndYmdString
            }
            self.passwordClone = JSON.parse(JSON.stringify(self.password))
            self.chipColorTmp = self.rec.mstJinin.color
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('★★★savedInputRestorePromise★★★')
            // ユーザ保存項目の復元
            var jomuFlgBool = c.jomuFlg === 'true'
            self.rec.mstJinin.jomuFlg = jomuFlgBool
            var taeigyoshoSousaKanouFlgBool = c.taeigyoshoSousaKanouFlg === 'true'
            self.rec.mstJinin.taeigyoshoSousaKanouFlg = taeigyoshoSousaKanouFlgBool
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('★★★existsIdMethod★★★', self.id)
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★')
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (self.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingItemMethod', kengen)
            self.passwordCurrentDisp = false
            if (self.modeOfEdit === 2 && self.rec.mstJinin.password !== ' ') {
              // 更新モード password: ' ' = 未入力
              self.passwordCurrentDisp = true
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('★★★onReturnButtonClick★★★', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('★★★onCancelButtonClick★★★', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            self.initialize()
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onNewButtonClick: function (e) {
      // キー情報初期化
      this.id = 0
      this.initialize()
    },
    onDeleteButtonClick: function (e) {
      console.log('★★★onDeleteButtonClick★★★', e)
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData
            self.HttpClient.post(`/api/v1/vwCMstJinin/deleteMulti?id=${self.id}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          // 更新ではなく新規登録用データに変更
          self.id = 0
          self.rec.mstJinin.id = 0
          self.rec.mstFaceImageRegistFlg = true
          self.rec.photoDeleteFlg = false
          self.copyMode = true
          self.modeOfEdit = 0
          // パスワードを初期設定状態にする
          self.rec.passwordRegistFlg = false
          self.rec.mstJinin.password = ' '
          self.password.passwordNew = ''
          self.password.passwordAgain = ''
          self.passwordClone.passwordNew = ''
          self.passwordClone.passwordAgain = ''
          self.passwordCurrentDisp = false
          // 人員マスタに紐づく各マスタ
          self.rec.mstFaceImage.id = -1
          self.rec.mstJukyoJoho.id = -1
          // 運転免許情報マスタ
          self.rec.mstMenkyoshoDel = []
          self.rec.mstMenkyosho = self.rec.mstMenkyosho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 家族情報マスタ
          self.rec.mstKazokuJohoDel = []
          self.rec.mstKazokuJoho = self.rec.mstKazokuJoho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 人事変更マスタ
          self.rec.mstJinjiHenkoDel = []
          self.rec.mstJinjiHenko = self.rec.mstJinjiHenko.map((elem) => {
            elem.id = -1
            return elem
          })
          // 履歴情報マスタ
          self.rec.mstRirekiJohoDel = []
          self.rec.mstRirekiJoho = self.rec.mstRirekiJoho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 経歴情報マスタ
          self.rec.mstKeirekiJohoDel = []
          self.rec.mstKeirekiJoho = self.rec.mstKeirekiJoho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 資格情報マスタ
          self.rec.mstShikakuJohoDel = []
          self.rec.mstShikakuJoho = self.rec.mstShikakuJoho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 賞罰情報マスタ
          self.rec.mstShobatsuJohoDel = []
          self.rec.mstShobatsuJoho = self.rec.mstShobatsuJoho.map((elem) => {
            elem.id = -1
            return elem
          })
          // 適性診断マスタ
          self.rec.mstTekiseiShindanDel = []
          self.rec.mstTekiseiShindan = self.rec.mstTekiseiShindan.map((elem) => {
            elem.id = -1
            return elem
          })
          // 事故歴マスタ
          self.rec.mstJikorekiDel = []
          self.rec.mstJikoreki = self.rec.mstJikoreki.map((elem) => {
            elem.id = -1
            return elem
          })
          // 違反歴マスタ
          self.rec.mstIhanrekiDel = []
          self.rec.mstIhanreki = self.rec.mstIhanreki.map((elem) => {
            elem.id = -1
            return elem
          })
          // 特別教育マスタ
          self.rec.mstTokubetsuKyoikuDel = []
          self.rec.mstTokubetsuKyoiku = self.rec.mstTokubetsuKyoiku.map((elem) => {
            elem.id = -1
            return elem
          })
          // 健康診断マスタ
          self.rec.mstKenkoShindanDel = []
          self.rec.mstKenkoShindan = self.rec.mstKenkoShindan.map((elem) => {
            elem.id = -1
            return elem
          })
          // クローンデータ上書き（キャンセル実行時に家族情報などが複写元のデータのIDに上書かれるのを防ぐ）
          self.cloneData = JSON.parse(JSON.stringify(self.rec))
        }
      }
      this.copyInputs(opt)
    },
    onReportButtonClick: function (e) {
      console.log('★★★onReportButtonClick★★★', e)
    },
    onSaveButtonClick: function (e) {
      console.log('★★★onSaveButtonClick★★★', e)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            // payloadにidを直接設定している
            self.id = data.payload
            self.copyMode = false
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.mstJinin.jininCd !== this.rec.mstJinin.jininCd
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.transition(1, { id: id }, self.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
            jomuFlg: self.rec.mstJinin.jomuFlg,
            taeigyoshoSousaKanouFlg: self.rec.mstJinin.taeigyoshoSousaKanouFlg
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      console.log('★★★registerPromise★★★', this.id)
      let f
      /* --------------------
        入力項目動的DOMの値を更新データに設定
      -------------------- */
      var propertyNm
      // 支給項目単価
      for (propertyNm of Object.keys(this.rec.shikyuKomokuTanka)) {
        if (propertyNm.indexOf('shikyuKomokuTanka') === 0) {
          this.rec.mstJinin[propertyNm] = this.rec.shikyuKomokuTanka[propertyNm]
        }
      }
      // 控除項目単価
      for (propertyNm of Object.keys(this.rec.koujoKomokuTanka)) {
        if (propertyNm.indexOf('koujoKomokuTanka') === 0) {
          this.rec.mstJinin[propertyNm] = this.rec.koujoKomokuTanka[propertyNm]
        }
      }
      /* --------------------
        各マスタ入力確認（入力がない場合は更新データとして含めない）
        特定の項目に入力がない場合は、入力項目の必須属性化が行われるため、他の関連項目にも入力がないと判断
      -------------------- */
      // 顔写真マスタ
      // 写真アップロード処理が行われていないため
      if ([undefined, null, ''].includes(this.rec.mstFaceImage.faceImage)) {
        this.rec.mstFaceImageRegistFlg = false
      }
      // 運転免許情報マスタ
      if (this.rec.menkyoshoNo.length === 0) {
        this.rec.mstMenkyoshoRegistFlg = false
      } else {
        this.rec.mstMenkyoshoRegistFlg = true
      }
      // 家族情報マスタ
      if (this.rec.mstKazokuJoho.length === 0) {
        this.rec.mstKazokuJohoRegistFlg = false
      } else {
        if (!this.rec.mstKazokuJoho[0].familyNmSei) {
          this.rec.mstKazokuJohoRegistFlg = false
        } else {
          this.rec.mstKazokuJohoRegistFlg = true
        }
      }
      // 人事変更マスタ
      if (this.rec.mstJinjiHenko.length === 0) {
        this.rec.mstJinjiHenkoRegistFlg = false
      } else {
        if (!this.rec.mstJinjiHenko[0].henkoYmdString) {
          this.rec.mstJinjiHenkoRegistFlg = false
        } else {
          this.rec.mstJinjiHenkoRegistFlg = true
        }
      }
      // 履歴情報マスタ
      if (this.rec.mstRirekiJoho.length === 0) {
        this.rec.mstRirekiJohoRegistFlg = false
      } else {
        if (!this.rec.mstRirekiJoho[0].rirekiYmdString) {
          this.rec.mstRirekiJohoRegistFlg = false
        } else {
          this.rec.mstRirekiJohoRegistFlg = true
        }
      }
      // 経歴情報マスタ
      if (this.rec.mstKeirekiJoho.length === 0) {
        this.rec.mstKeirekiJohoRegistFlg = false
      } else {
        if (!this.rec.mstKeirekiJoho[0].shakenshoSbt &&
            !this.rec.mstKeirekiJoho[0].teiinQty &&
            !this.rec.mstKeirekiJoho[0].sekisairyo &&
            !this.rec.mstKeirekiJoho[0].keikenYmYear &&
            !this.rec.mstKeirekiJoho[0].keikenYmMonth &&
            !this.rec.mstKeirekiJoho[0].jigyoshoNm) {
          this.rec.mstKeirekiJohoRegistFlg = false
        } else {
          this.rec.mstKeirekiJohoRegistFlg = true
        }
      }
      // 資格情報マスタ
      if (this.rec.mstShikakuJoho.length === 0) {
        this.rec.mstShikakuJohoRegistFlg = false
      } else {
        if (!this.rec.mstShikakuJoho[0].shikakuShutokuYmdString) {
          this.rec.mstShikakuJohoRegistFlg = false
        } else {
          this.rec.mstShikakuJohoRegistFlg = true
        }
      }
      // 賞罰情報マスタ
      if (this.rec.mstShobatsuJoho.length === 0) {
        this.rec.mstShobatsuJohoRegistFlg = false
      } else {
        if (!this.rec.mstShobatsuJoho[0].shobatsuYmdString) {
          this.rec.mstShobatsuJohoRegistFlg = false
        } else {
          this.rec.mstShobatsuJohoRegistFlg = true
        }
      }
      // 適性診断マスタ
      if (this.rec.mstTekiseiShindan.length === 0) {
        this.rec.mstTekiseiShindanRegistFlg = false
      } else {
        if (!this.rec.mstTekiseiShindan[0].jishiYmdString) {
          this.rec.mstTekiseiShindanRegistFlg = false
        } else {
          this.rec.mstTekiseiShindanRegistFlg = true
        }
      }
      // 事故歴マスタ
      if (this.rec.mstJikoreki.length === 0) {
        this.rec.mstJikorekiRegistFlg = false
      } else {
        if (!this.rec.mstJikoreki[0].haseiYmdString) {
          this.rec.mstJikorekiRegistFlg = false
        } else {
          this.rec.mstJikorekiRegistFlg = true
        }
      }
      // 違反歴マスタ
      if (this.rec.mstIhanreki.length === 0) {
        this.rec.mstIhanrekiRegistFlg = false
      } else {
        if (!this.rec.mstIhanreki[0].ihanYmdString) {
          this.rec.mstIhanrekiRegistFlg = false
        } else {
          this.rec.mstIhanrekiRegistFlg = true
        }
      }
      // 特別教育マスタ
      if (this.rec.mstTokubetsuKyoiku.length === 0) {
        this.rec.mstTokubetsuKyoikuRegistFlg = false
      } else {
        if (!this.rec.mstTokubetsuKyoiku[0].jishiYmdString) {
          this.rec.mstTokubetsuKyoikuRegistFlg = false
        } else {
          this.rec.mstTokubetsuKyoikuRegistFlg = true
        }
      }
      // 健康診断マスタpasswordCurrentDisp
      // どの項目も必須属性化しないため各行入力確認
      if (this.rec.mstKenkoShindan.length === 0) {
        this.rec.mstKenkoShindanRegistFlg = false
      } else {
        this.rec.mstKenkoShindan = this.rec.mstKenkoShindan.filter(function (elem) {
          return elem.jishiYmdString || elem.jishiKikanNm || elem.shokenTekiyo
        })
        if (this.rec.mstKenkoShindan.length === 0) {
          this.rec.mstKenkoShindanRegistFlg = false
        } else {
          this.rec.mstKenkoShindanRegistFlg = true
        }
      }
      /* --------------------
        更新処理
      -------------------- */
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/vwCMstJinin/createMulti', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/vwCMstJinin/updateMulti?id=${this.id}`, this.rec)
      }
      return f
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      console.log('**onPdfButtonClick', this.id)
      const self = this
      this.HttpClient
        .requestFileByPost(`/api/v1/vwCMstJinin/pdfdownload?id=${this.id}`)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = `乗務員台帳_${self.rec.mstJinin.jininNmSei.replace(' ', '').replace('　', '')}.pdf`
          elem.click()
          this.Effects.loadComplete()
        })
    },
    registerValidate: function () {
      // 適用年月日の大小チェック
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    deleteValidate: function () {
      if (this.cloneData.mstJinin.jininCd !== this.rec.mstJinin.jininCd) {
        this.rec.mstJinin.jininCd = this.cloneData.mstJinin.jininCd
        this.$refs.jininCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['人員コード']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      return true
    },
    onUndoChipColor: function () {
      this.rec.mstJinin.color = this.chipColorTmp
    }
  }
}
